import React, { useEffect } from 'react'

function RedirectSolutionForm({card}) {
    console.log(card);

      useEffect(() => {
    // Extract the generated URL from card data
    const redirectUrl = card?.data?.generatedUrl;
    
    // Redirect immediately if URL exists
    if (redirectUrl && redirectUrl !== '#' && redirectUrl !== '') {
      window.location.href = redirectUrl;
    }
  }, [card]);
    
  return (

     <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4'>
            {card?.formType === "text_simpleForm" ? (
                <div className='max-w-2xl w-full bg-white rounded-xl shadow-lg p-8'>
                    <div className='text-center'>
                        {/* Icon */}
                        <div className='w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6'>
                            <svg className='w-8 h-8 text-white' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' />
                            </svg>
                        </div>
                        
                        {/* Title */}
                        <h2 className='text-2xl font-bold text-gray-800 mb-4'>
                            Text Message
                        </h2>
                        
                        {/* Text Content */}
                        <div className='bg-gray-50 rounded-lg p-6 border-l-4 border-blue-500'>
                            <p className='text-lg font-medium text-gray-700 leading-relaxed break-words whitespace-pre-wrap'>
                                {card?.data?.text}
                            </p>
                        </div>
                        
                   
                    </div>
                </div>
            ) : (
                // Loading state for other form types while redirecting
                <div className='text-center'>
                    <div className='w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4'></div>
                    <p className='text-lg text-gray-600'>Redirecting...</p>
                </div>
            )}
        </div>
  )
}

export default RedirectSolutionForm